import { render, staticRenderFns } from "./LinkWidget.vue?vue&type=template&id=9ddf0f68"
import script from "./LinkWidget.vue?vue&type=script&lang=js"
export * from "./LinkWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ddf0f68')) {
      api.createRecord('9ddf0f68', component.options)
    } else {
      api.reload('9ddf0f68', component.options)
    }
    module.hot.accept("./LinkWidget.vue?vue&type=template&id=9ddf0f68", function () {
      api.rerender('9ddf0f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/LinkWidget.vue"
export default component.exports